var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "uk-container uk-margin-large-bottom" }, [
    _c(
      "p",
      [
        _c(
          "router-link",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step === 1,
                expression: "step === 1"
              }
            ],
            attrs: { to: { name: "Trial" } }
          },
          [_vm._v(_vm._s(_vm.i18n["buy-subline"]))]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "uk-grid-collapse uk-grid-divider uk-child-width-expand@s",
        attrs: { "uk-grid": "" }
      },
      [
        _c("div", { staticClass: "uk-width-2-3@m" }, [
          _c(
            "div",
            { staticClass: "form-wrapper" },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.status !== "done"
                  ? _c("div", [
                      _c("progress", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.step < 6,
                            expression: "step < 6"
                          }
                        ],
                        staticClass: "uk-progress",
                        attrs: { max: "100" },
                        domProps: { value: 16.66 * _vm.step }
                      }),
                      _vm._v(" "),
                      _c("ul", { staticClass: "uk-list" }, [
                        _vm.step === 1
                          ? _c("li", [
                              _vm.customer.plan.variant !== "educational"
                                ? _c(
                                    "div",
                                    [
                                      _c("h2", [
                                        _vm._v(
                                          "1. " +
                                            _vm._s(_vm.i18n["step1-headline"])
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("ValidationObserver", {
                                        ref: "step1",
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var invalid = ref.invalid
                                                return [
                                                  _c(
                                                    "form",
                                                    {
                                                      staticClass:
                                                        "uk-form-stacked",
                                                      attrs: { novalidate: "" },
                                                      on: {
                                                        submit: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          $event.preventDefault()
                                                          return _vm.toStep(2)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            "uk-grid": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "uk-width-1-4@m"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label",
                                                                  attrs: {
                                                                    for:
                                                                      "form-stacked-text"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.i18n[
                                                                        "step1-numberofusers"
                                                                      ]
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-controls"
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .customer
                                                                            .plan
                                                                            .users,
                                                                        expression:
                                                                          "customer.plan.users"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-input uk-form-width-small",
                                                                    attrs: {
                                                                      min: "1",
                                                                      id:
                                                                        "planUsers",
                                                                      name:
                                                                        "planUsers",
                                                                      type:
                                                                        "number"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .customer
                                                                          .plan
                                                                          .users
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .customer
                                                                            .plan,
                                                                          "users",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("div", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm
                                                                        .customer
                                                                        .plan
                                                                        .users >
                                                                      250,
                                                                    expression:
                                                                      "customer.plan.users > 250"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "uk-margin",
                                                                domProps: {
                                                                  innerHTML: _vm._s(
                                                                    _vm.i18n[
                                                                      "step1-numberofuserserrormax"
                                                                    ]
                                                                  )
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "uk-width-2-3@s"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "uk-flex"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "planchooser uk-text-center yearly uk-width-1-2",
                                                                      class: {
                                                                        inactive:
                                                                          _vm
                                                                            .customer
                                                                            .plan
                                                                            .interval ===
                                                                          "monthly"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.customer.plan.interval =
                                                                            "yearly"
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "header"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .i18n[
                                                                                  "planchooser-mostpopular"
                                                                                ]
                                                                              ) +
                                                                              "\n                              "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "content"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "h4",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .i18n[
                                                                                    "planchooser-billedyearly"
                                                                                  ]
                                                                                )
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "uk-text-primary"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .i18n[
                                                                                        "planchooser-savings"
                                                                                      ]
                                                                                    ) +
                                                                                      " " +
                                                                                      _vm._s(
                                                                                        _vm.yearlySavingsProcComp
                                                                                      ) +
                                                                                      "%"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "h5",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.totalStorageComp
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "currency"
                                                                                    )(
                                                                                      _vm
                                                                                        .billwerk
                                                                                        .plans[
                                                                                        _vm
                                                                                          .customer
                                                                                          .plan
                                                                                          .variant
                                                                                      ]
                                                                                        .yearly
                                                                                        .price /
                                                                                        12,
                                                                                      _vm
                                                                                        .currencies[
                                                                                        _vm
                                                                                          .activeCurrency
                                                                                      ]
                                                                                    )
                                                                                  ) +
                                                                                  " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "planchooser-peruserpermonth"
                                                                                    ]
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "currency"
                                                                                    )(
                                                                                      _vm.yearlyTotalComp,
                                                                                      _vm
                                                                                        .currencies[
                                                                                        _vm
                                                                                          .activeCurrency
                                                                                      ]
                                                                                    )
                                                                                  ) +
                                                                                  " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "planchooser-chargeyearly"
                                                                                    ]
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "planchooser uk-text-center uk-width-1-2",
                                                                      class: {
                                                                        inactive:
                                                                          _vm
                                                                            .customer
                                                                            .plan
                                                                            .interval ===
                                                                          "yearly"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.customer.plan.interval =
                                                                            "monthly"
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "header uk-padding"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "content"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "h4",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .i18n[
                                                                                    "planchooser-billedmonthly"
                                                                                  ]
                                                                                )
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "uk-text-primary"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "h5",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.totalStorageComp
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "currency"
                                                                                    )(
                                                                                      _vm
                                                                                        .billwerk
                                                                                        .plans[
                                                                                        _vm
                                                                                          .customer
                                                                                          .plan
                                                                                          .variant
                                                                                      ]
                                                                                        .monthly
                                                                                        .price,
                                                                                      _vm
                                                                                        .currencies[
                                                                                        _vm
                                                                                          .activeCurrency
                                                                                      ]
                                                                                    )
                                                                                  ) +
                                                                                  " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "planchooser-peruserpermonth"
                                                                                    ]
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "currency"
                                                                                    )(
                                                                                      _vm.monthlyTotalComp,
                                                                                      _vm
                                                                                        .currencies[
                                                                                        _vm
                                                                                          .activeCurrency
                                                                                      ]
                                                                                    )
                                                                                  ) +
                                                                                  " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "planchooser-chargemonthly"
                                                                                    ]
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "uk-margin uk-text-small"
                                                                },
                                                                [
                                                                  _vm.customer
                                                                    .plan
                                                                    .interval ===
                                                                  "monthly"
                                                                    ? [
                                                                        _c(
                                                                          "p",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .i18n[
                                                                                    "planchooser-yourselectiontextmonthly"
                                                                                  ]
                                                                                ) +
                                                                                "\n                              "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    : _vm
                                                                        .customer
                                                                        .plan
                                                                        .interval ===
                                                                      "yearly"
                                                                    ? [
                                                                        _c(
                                                                          "p",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .i18n[
                                                                                    "planchooser-yourselectiontextyearly"
                                                                                  ]
                                                                                ) +
                                                                                "\n                              "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    : _vm._e()
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        _vm.status ===
                                                                        "too_much_users",
                                                                      expression:
                                                                        "status === 'too_much_users'"
                                                                    }
                                                                  ]
                                                                },
                                                                [
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "uk-text-small",
                                                                    attrs: {
                                                                      "uk-alert":
                                                                        ""
                                                                    },
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        _vm
                                                                          .i18n[
                                                                          "planchooser-basic-hint-users"
                                                                        ]
                                                                      )
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "coupon-wrap uk-margin"
                                                        },
                                                        [
                                                          _c(
                                                            "ValidationProvider",
                                                            {
                                                              attrs: {
                                                                name: "coupon"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var errors =
                                                                        ref.errors
                                                                      var classes =
                                                                        ref.classes
                                                                      return [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "uk-margin uk-child-width-expand@s uk-flex uk-grid-small",
                                                                            attrs: {
                                                                              "uk-grid":
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "label",
                                                                                  {
                                                                                    staticClass:
                                                                                      "uk-form-label",
                                                                                    attrs: {
                                                                                      for:
                                                                                        "coupon"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm
                                                                                          .i18n[
                                                                                          "step1-adddiscountcode"
                                                                                        ]
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "uk-form-controls uk-position-relative"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        directives: [
                                                                                          {
                                                                                            name:
                                                                                              "show",
                                                                                            rawName:
                                                                                              "v-show",
                                                                                            value:
                                                                                              _vm
                                                                                                .customer
                                                                                                .data
                                                                                                .coupon !==
                                                                                                "" &&
                                                                                              errors.length ===
                                                                                                0,
                                                                                            expression:
                                                                                              "customer.data.coupon !== '' && errors.length === 0"
                                                                                          }
                                                                                        ],
                                                                                        staticClass:
                                                                                          "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "input",
                                                                                      {
                                                                                        directives: [
                                                                                          {
                                                                                            name:
                                                                                              "model",
                                                                                            rawName:
                                                                                              "v-model",
                                                                                            value:
                                                                                              _vm
                                                                                                .customer
                                                                                                .data
                                                                                                .coupon,
                                                                                            expression:
                                                                                              "customer.data.coupon"
                                                                                          }
                                                                                        ],
                                                                                        staticClass:
                                                                                          "uk-input",
                                                                                        class: classes,
                                                                                        attrs: {
                                                                                          type:
                                                                                            "text"
                                                                                        },
                                                                                        domProps: {
                                                                                          value:
                                                                                            _vm
                                                                                              .customer
                                                                                              .data
                                                                                              .coupon
                                                                                        },
                                                                                        on: {
                                                                                          input: function(
                                                                                            $event
                                                                                          ) {
                                                                                            if (
                                                                                              $event
                                                                                                .target
                                                                                                .composing
                                                                                            ) {
                                                                                              return
                                                                                            }
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .customer
                                                                                                .data,
                                                                                              "coupon",
                                                                                              $event
                                                                                                .target
                                                                                                .value
                                                                                            )
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "field-check uk-width-1-4@m"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "label",
                                                                                  {
                                                                                    staticClass:
                                                                                      "uk-form-label uk-visible@m"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                errors.length >
                                                                                0
                                                                                  ? _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "uk-form-danger"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "fas fa-times"
                                                                                          }
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              _vm
                                                                                                .i18n[
                                                                                                "step1-invalidcoupon"
                                                                                              ]
                                                                                            )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    directives: [
                                                                                      {
                                                                                        name:
                                                                                          "show",
                                                                                        rawName:
                                                                                          "v-show",
                                                                                        value:
                                                                                          _vm
                                                                                            .coupon
                                                                                            .status ===
                                                                                            true &&
                                                                                          _vm
                                                                                            .customer
                                                                                            .data
                                                                                            .coupon !=
                                                                                            "" &&
                                                                                          errors.length ===
                                                                                            0,
                                                                                        expression:
                                                                                          "coupon.status === true && customer.data.coupon != '' && errors.length === 0"
                                                                                      }
                                                                                    ],
                                                                                    staticClass:
                                                                                      "uk-form-success uk-visible@m"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "fas fa-check"
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    directives: [
                                                                                      {
                                                                                        name:
                                                                                          "show",
                                                                                        rawName:
                                                                                          "v-show",
                                                                                        value:
                                                                                          _vm.checkField ===
                                                                                          "coupon",
                                                                                        expression:
                                                                                          "checkField === 'coupon'"
                                                                                      }
                                                                                    ],
                                                                                    staticClass:
                                                                                      "uk-visible@m"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "fas fa-circle-notch fa-spin"
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "uk-flex uk-flex-right uk-margin-top"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "uk-button uk-button-primary",
                                                              attrs: {
                                                                type: "submit",
                                                                disabled:
                                                                  invalid ||
                                                                  _vm.status ===
                                                                    "updateing_summary"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.i18n[
                                                                    "button-next"
                                                                  ]
                                                                ) + " "
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "fas fa-arrow-right"
                                                              })
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2371835549
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _c(
                                      "form",
                                      {
                                        staticClass: "uk-form-stacked",
                                        attrs: { novalidate: "" },
                                        on: {
                                          submit: function($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.toStep(2)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "uk-grid",
                                            attrs: {
                                              "uk-height-match": ".list",
                                              "uk-grid": ""
                                            }
                                          },
                                          _vm._l(
                                            _vm.i18n.plans.educational
                                              .planVariants,
                                            function(variant) {
                                              return _c(
                                                "div",
                                                {
                                                  key: variant.id,
                                                  staticClass: "uk-width-1-2@s"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "uk-card uk-card-default uk-card-hover uk-card-body",
                                                      class: {
                                                        "uk-card-secondary":
                                                          _vm.billwerk.plans
                                                            .educational
                                                            .selected ===
                                                          variant.id
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "uk-text-center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(variant.name)
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            variant.text
                                                          )
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "uk-button uk-display-block uk-button-primary uk-width-1-1",
                                                          attrs: {
                                                            type: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.eduSelect(
                                                                variant.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.i18n[
                                                                "button-select"
                                                              ]
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "uk-flex uk-flex-right uk-margin-top"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "uk-button uk-button-primary",
                                                attrs: {
                                                  type: "submit",
                                                  disabled:
                                                    _vm.status === "saving"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.i18n["button-next"]
                                                  ) + " "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-arrow-right"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.step === 2
                          ? _c(
                              "li",
                              [
                                _c("h2", [
                                  _vm._v(
                                    "2. " + _vm._s(_vm.i18n["step2-headline"])
                                  )
                                ]),
                                _vm._v(" "),
                                _c("ValidationObserver", {
                                  ref: "step2",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var invalid = ref.invalid
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "form",
                                              {
                                                staticClass: "uk-form-stacked",
                                                attrs: { novalidate: "" },
                                                on: {
                                                  submit: function($event) {
                                                    $event.stopPropagation()
                                                    $event.preventDefault()
                                                    return _vm.toStep(3)
                                                  }
                                                }
                                              },
                                              [
                                                _c("ValidationProvider", {
                                                  staticClass:
                                                    "uk-child-width-expand@s uk-flex uk-grid-small",
                                                  attrs: {
                                                    name: "firstName",
                                                    rules: "required",
                                                    tag: "div",
                                                    "uk-grid": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var failed =
                                                            ref.failed
                                                          var dirty = ref.dirty
                                                          var passed =
                                                            ref.passed
                                                          var classes =
                                                            ref.classes
                                                          return [
                                                            _c("div", [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label",
                                                                  attrs: {
                                                                    for:
                                                                      "firstName"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.i18n[
                                                                        "step2-firstname"
                                                                      ]
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-controls uk-position-relative"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: passed,
                                                                        expression:
                                                                          "passed"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .customer
                                                                            .data
                                                                            .firstName,
                                                                        expression:
                                                                          "customer.data.firstName"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-input",
                                                                    class: classes,
                                                                    attrs: {
                                                                      type:
                                                                        "text"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .customer
                                                                          .data
                                                                          .firstName
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .customer
                                                                            .data,
                                                                          "firstName",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "field-check uk-width-1-4@m"
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "uk-form-label uk-visible@m"
                                                                  },
                                                                  [_vm._v(" ")]
                                                                ),
                                                                _vm._v(" "),
                                                                dirty && failed
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-danger"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-times"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .i18n[
                                                                                "step2-firstnameerror"
                                                                              ]
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: passed,
                                                                        expression:
                                                                          "passed"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-form-success uk-visible@m"
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-check"
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _vm._v(" "),
                                                _c("ValidationProvider", {
                                                  staticClass:
                                                    "uk-child-width-expand@s uk-flex uk-grid-small",
                                                  attrs: {
                                                    name: "lastName",
                                                    rules: "required",
                                                    tag: "div",
                                                    "uk-grid": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var failed =
                                                            ref.failed
                                                          var dirty = ref.dirty
                                                          var passed =
                                                            ref.passed
                                                          var errors =
                                                            ref.errors
                                                          var classes =
                                                            ref.classes
                                                          return [
                                                            _c("div", [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label",
                                                                  attrs: {
                                                                    for:
                                                                      "lastName"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.i18n[
                                                                        "step2-lastname"
                                                                      ]
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-controls uk-position-relative"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: passed,
                                                                        expression:
                                                                          "passed"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .customer
                                                                            .data
                                                                            .lastName,
                                                                        expression:
                                                                          "customer.data.lastName"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-input",
                                                                    class: classes,
                                                                    attrs: {
                                                                      type:
                                                                        "text"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .customer
                                                                          .data
                                                                          .lastName
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .customer
                                                                            .data,
                                                                          "lastName",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "field-check uk-width-1-4@m"
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "uk-form-label uk-visible@m"
                                                                  },
                                                                  [_vm._v(" ")]
                                                                ),
                                                                _vm._v(" "),
                                                                dirty && failed
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-danger"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-times"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                errors[0]
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .i18n[
                                                                                "step2-lastnameerror"
                                                                              ]
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: passed,
                                                                        expression:
                                                                          "passed"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-form-success uk-visible@m"
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-check"
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _vm._v(" "),
                                                _c("ValidationProvider", {
                                                  staticClass:
                                                    "uk-child-width-expand@s uk-flex uk-grid-small",
                                                  attrs: {
                                                    name: "street",
                                                    rules: "required",
                                                    tag: "div",
                                                    "uk-grid": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var failed =
                                                            ref.failed
                                                          var dirty = ref.dirty
                                                          var passed =
                                                            ref.passed
                                                          var errors =
                                                            ref.errors
                                                          var classes =
                                                            ref.classes
                                                          return [
                                                            _c("div", [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label",
                                                                  attrs: {
                                                                    for:
                                                                      "street"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.i18n[
                                                                        "step2-street"
                                                                      ]
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-controls uk-position-relative"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: passed,
                                                                        expression:
                                                                          "passed"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .customer
                                                                            .data
                                                                            .street,
                                                                        expression:
                                                                          "customer.data.street"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-input",
                                                                    class: classes,
                                                                    attrs: {
                                                                      type:
                                                                        "text"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .customer
                                                                          .data
                                                                          .street
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .customer
                                                                            .data,
                                                                          "street",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "field-check uk-width-1-4@m"
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "uk-form-label uk-visible@m"
                                                                  },
                                                                  [_vm._v(" ")]
                                                                ),
                                                                _vm._v(" "),
                                                                dirty && failed
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-danger"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-times"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                errors[0]
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .i18n[
                                                                                "step2-streeterror"
                                                                              ]
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: passed,
                                                                        expression:
                                                                          "passed"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-form-success uk-visible@m"
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-check"
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uk-child-width-expand@s uk-flex uk-grid-small",
                                                    attrs: { "uk-grid": "" }
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          attrs: {
                                                            "uk-grid": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "ValidationProvider",
                                                            {
                                                              staticClass:
                                                                "uk-form-controls uk-width-1-3",
                                                              attrs: {
                                                                vid:
                                                                  "postalCode",
                                                                name:
                                                                  "postalCode",
                                                                rules:
                                                                  "required|required:@city",
                                                                tag: "div"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var passed =
                                                                        ref.passed
                                                                      var classes =
                                                                        ref.classes
                                                                      return [
                                                                        _c(
                                                                          "label",
                                                                          {
                                                                            staticClass:
                                                                              "uk-form-label",
                                                                            attrs: {
                                                                              for:
                                                                                "postalCode"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .i18n[
                                                                                  "step2-zip"
                                                                                ]
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "uk-form-controls uk-position-relative"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "show",
                                                                                    rawName:
                                                                                      "v-show",
                                                                                    value: passed,
                                                                                    expression:
                                                                                      "passed"
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .customer
                                                                                        .data
                                                                                        .postalCode,
                                                                                    expression:
                                                                                      "customer.data.postalCode"
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "uk-input",
                                                                                class: classes,
                                                                                attrs: {
                                                                                  type:
                                                                                    "text"
                                                                                },
                                                                                domProps: {
                                                                                  value:
                                                                                    _vm
                                                                                      .customer
                                                                                      .data
                                                                                      .postalCode
                                                                                },
                                                                                on: {
                                                                                  input: function(
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    ) {
                                                                                      return
                                                                                    }
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .customer
                                                                                        .data,
                                                                                      "postalCode",
                                                                                      $event
                                                                                        .target
                                                                                        .value
                                                                                    )
                                                                                  }
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "ValidationProvider",
                                                            {
                                                              staticClass:
                                                                "uk-form-controls uk-position-relative uk-width-2-3",
                                                              attrs: {
                                                                vid: "city",
                                                                name: "city",
                                                                rules:
                                                                  "required",
                                                                tag: "div"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var passed =
                                                                        ref.passed
                                                                      var classes =
                                                                        ref.classes
                                                                      return [
                                                                        _c(
                                                                          "label",
                                                                          {
                                                                            staticClass:
                                                                              "uk-form-label",
                                                                            attrs: {
                                                                              for:
                                                                                "city"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .i18n[
                                                                                  "step2-city"
                                                                                ]
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "uk-form-controls uk-position-relative"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "show",
                                                                                    rawName:
                                                                                      "v-show",
                                                                                    value: passed,
                                                                                    expression:
                                                                                      "passed"
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .customer
                                                                                        .data
                                                                                        .city,
                                                                                    expression:
                                                                                      "customer.data.city"
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "uk-input",
                                                                                class: classes,
                                                                                attrs: {
                                                                                  type:
                                                                                    "text"
                                                                                },
                                                                                domProps: {
                                                                                  value:
                                                                                    _vm
                                                                                      .customer
                                                                                      .data
                                                                                      .city
                                                                                },
                                                                                on: {
                                                                                  input: function(
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    ) {
                                                                                      return
                                                                                    }
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .customer
                                                                                        .data,
                                                                                      "city",
                                                                                      $event
                                                                                        .target
                                                                                        .value
                                                                                    )
                                                                                  }
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "field-check uk-width-1-4@m"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "uk-form-label uk-visible@m"
                                                          },
                                                          [_vm._v(" ")]
                                                        ),
                                                        _vm._v(" "),
                                                        errors.postalCode &&
                                                        errors.postalCode
                                                          .length > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "uk-form-danger"
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-times"
                                                                }),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[
                                                                        "postalCode"
                                                                      ][0]
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  errors.postalCode &&
                                                                  errors
                                                                    .postalCode
                                                                    .length ===
                                                                    0 &&
                                                                  _vm.customer
                                                                    .data
                                                                    .postalCode
                                                                    .length >
                                                                    0 &&
                                                                  _vm.customer
                                                                    .data.city
                                                                    .length > 0,
                                                                expression:
                                                                  "errors.postalCode && errors.postalCode.length === 0 && customer.data.postalCode.length > 0 && customer.data.city.length > 0"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "uk-form-success uk-visible@m"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-check"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("ValidationProvider", {
                                                  staticClass:
                                                    "uk-child-width-expand@s uk-flex uk-grid-small",
                                                  attrs: {
                                                    name: "country",
                                                    rules: "required",
                                                    tag: "div",
                                                    "uk-grid": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var failed =
                                                            ref.failed
                                                          var dirty = ref.dirty
                                                          var passed =
                                                            ref.passed
                                                          var errors =
                                                            ref.errors
                                                          var classes =
                                                            ref.classes
                                                          return [
                                                            _c("div", [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label",
                                                                  attrs: {
                                                                    for:
                                                                      "country"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.i18n[
                                                                        "step2-country"
                                                                      ]
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-controls uk-position-relative"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: passed,
                                                                        expression:
                                                                          "passed"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .customer
                                                                              .data
                                                                              .country,
                                                                          expression:
                                                                            "customer.data.country"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "uk-select",
                                                                      class: classes,
                                                                      attrs: {
                                                                        id:
                                                                          "country"
                                                                      },
                                                                      on: {
                                                                        change: function(
                                                                          $event
                                                                        ) {
                                                                          var $$selectedVal = Array.prototype.filter
                                                                            .call(
                                                                              $event
                                                                                .target
                                                                                .options,
                                                                              function(
                                                                                o
                                                                              ) {
                                                                                return o.selected
                                                                              }
                                                                            )
                                                                            .map(
                                                                              function(
                                                                                o
                                                                              ) {
                                                                                var val =
                                                                                  "_value" in
                                                                                  o
                                                                                    ? o._value
                                                                                    : o.value
                                                                                return val
                                                                              }
                                                                            )
                                                                          _vm.$set(
                                                                            _vm
                                                                              .customer
                                                                              .data,
                                                                            "country",
                                                                            $event
                                                                              .target
                                                                              .multiple
                                                                              ? $$selectedVal
                                                                              : $$selectedVal[0]
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    _vm._l(
                                                                      _vm.countries.getNames(
                                                                        _vm.i18n
                                                                          .language
                                                                      ),
                                                                      function(
                                                                        country,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "option",
                                                                          {
                                                                            key: index,
                                                                            domProps: {
                                                                              value: index
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                country
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ]
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "field-check uk-width-1-4@m"
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "uk-form-label uk-visible@m"
                                                                  },
                                                                  [_vm._v(" ")]
                                                                ),
                                                                _vm._v(" "),
                                                                dirty && failed
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-danger"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-times"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                errors[0]
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .i18n[
                                                                                "step2-countryerror"
                                                                              ]
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value: passed,
                                                                        expression:
                                                                          "passed"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-form-success uk-visible@m"
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-check"
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uk-child-width-expand@s uk-flex uk-grid-small",
                                                    attrs: { "uk-grid": "" }
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.customer
                                                                  .type,
                                                              expression:
                                                                "customer.type"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "uk-radio",
                                                          attrs: {
                                                            type: "radio",
                                                            name:
                                                              "customerType",
                                                            value: "B"
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm.customer.type,
                                                              "B"
                                                            )
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.customer,
                                                                "type",
                                                                "B"
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.i18n[
                                                                "step2-b2b"
                                                              ]
                                                            )
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("div", [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.customer
                                                                  .type,
                                                              expression:
                                                                "customer.type"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "uk-radio",
                                                          attrs: {
                                                            type: "radio",
                                                            name:
                                                              "customerType",
                                                            value: "C"
                                                          },
                                                          domProps: {
                                                            checked: _vm._q(
                                                              _vm.customer.type,
                                                              "C"
                                                            )
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.customer,
                                                                "type",
                                                                "C"
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.i18n[
                                                                "step2-b2c"
                                                              ]
                                                            )
                                                        )
                                                      ])
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.customer.type === "B"
                                                  ? [
                                                      _c("ValidationProvider", {
                                                        staticClass:
                                                          "uk-child-width-expand@s uk-flex uk-grid-small",
                                                        attrs: {
                                                          name: "company",
                                                          rules: "",
                                                          tag: "div",
                                                          "uk-grid": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var failed =
                                                                  ref.failed
                                                                var dirty =
                                                                  ref.dirty
                                                                var errors =
                                                                  ref.errors
                                                                var classes =
                                                                  ref.classes
                                                                return [
                                                                  _c("div", [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-label",
                                                                        attrs: {
                                                                          for:
                                                                            "company"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step2-companyname"
                                                                            ]
                                                                          ) +
                                                                            " (optional)"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-position-relative"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .data
                                                                                    .company !==
                                                                                  "",
                                                                                expression:
                                                                                  "customer.data.company !== ''"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .data
                                                                                    .company,
                                                                                expression:
                                                                                  "customer.data.company"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-input",
                                                                            class: classes,
                                                                            attrs: {
                                                                              type:
                                                                                "text"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm
                                                                                  .customer
                                                                                  .data
                                                                                  .company
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .customer
                                                                                    .data,
                                                                                  "company",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "field-check uk-width-1-4@m"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-label uk-visible@m"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      dirty &&
                                                                      failed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "uk-form-danger"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      errors[0]
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step2-companynameerror"
                                                                                    ]
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                _vm
                                                                                  .customer
                                                                                  .data
                                                                                  .company !==
                                                                                "",
                                                                              expression:
                                                                                "customer.data.company !== ''"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "uk-form-success uk-visible@m"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-check"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.vatRequired
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "uk-child-width-expand@s uk-flex uk-grid-small",
                                                              attrs: {
                                                                "uk-grid": ""
                                                              }
                                                            },
                                                            [
                                                              _c("div", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      "uk-grid":
                                                                        ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "ValidationProvider",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-width-1-3",
                                                                        attrs: {
                                                                          vid:
                                                                            "vatprefix",
                                                                          name:
                                                                            "vatprefix",
                                                                          rules:
                                                                            "",
                                                                          tag:
                                                                            "div"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "label",
                                                                          {
                                                                            staticClass:
                                                                              "uk-form-label",
                                                                            attrs: {
                                                                              for:
                                                                                "vat"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .i18n[
                                                                                  "step2-vat"
                                                                                ]
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "uk-form-controls uk-position-relative"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "select",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .customer
                                                                                        .data
                                                                                        .vatprefix,
                                                                                    expression:
                                                                                      "customer.data.vatprefix"
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "uk-select",
                                                                                attrs: {
                                                                                  id:
                                                                                    "vatprefix"
                                                                                },
                                                                                on: {
                                                                                  change: function(
                                                                                    $event
                                                                                  ) {
                                                                                    var $$selectedVal = Array.prototype.filter
                                                                                      .call(
                                                                                        $event
                                                                                          .target
                                                                                          .options,
                                                                                        function(
                                                                                          o
                                                                                        ) {
                                                                                          return o.selected
                                                                                        }
                                                                                      )
                                                                                      .map(
                                                                                        function(
                                                                                          o
                                                                                        ) {
                                                                                          var val =
                                                                                            "_value" in
                                                                                            o
                                                                                              ? o._value
                                                                                              : o.value
                                                                                          return val
                                                                                        }
                                                                                      )
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .customer
                                                                                        .data,
                                                                                      "vatprefix",
                                                                                      $event
                                                                                        .target
                                                                                        .multiple
                                                                                        ? $$selectedVal
                                                                                        : $$selectedVal[0]
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              _vm._l(
                                                                                _vm.europeanCountries,
                                                                                function(
                                                                                  country,
                                                                                  index
                                                                                ) {
                                                                                  return _c(
                                                                                    "option",
                                                                                    {
                                                                                      key: index,
                                                                                      domProps: {
                                                                                        value: country
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          country
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "ValidationProvider",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-width-2-3",
                                                                        attrs: {
                                                                          name:
                                                                            "vat",
                                                                          rules:
                                                                            "",
                                                                          tag:
                                                                            "div"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "label",
                                                                              {
                                                                                staticClass:
                                                                                  "uk-form-label",
                                                                                attrs: {
                                                                                  for:
                                                                                    "vat"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "uk-form-controls uk-position-relative"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    directives: [
                                                                                      {
                                                                                        name:
                                                                                          "show",
                                                                                        rawName:
                                                                                          "v-show",
                                                                                        value:
                                                                                          _vm.checkField !==
                                                                                            "vat" &&
                                                                                          _vm
                                                                                            .customer
                                                                                            .vatValid,
                                                                                        expression:
                                                                                          "checkField !== 'vat' && customer.vatValid"
                                                                                      }
                                                                                    ],
                                                                                    staticClass:
                                                                                      "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    directives: [
                                                                                      {
                                                                                        name:
                                                                                          "show",
                                                                                        rawName:
                                                                                          "v-show",
                                                                                        value:
                                                                                          _vm.checkField ===
                                                                                          "vat",
                                                                                        expression:
                                                                                          "checkField === 'vat'"
                                                                                      }
                                                                                    ],
                                                                                    staticClass:
                                                                                      "fas fa-circle-notch fa-spin uk-form-icon uk-form-icon-flip uk-hidden@m"
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "input",
                                                                                  {
                                                                                    directives: [
                                                                                      {
                                                                                        name:
                                                                                          "model",
                                                                                        rawName:
                                                                                          "v-model",
                                                                                        value:
                                                                                          _vm
                                                                                            .customer
                                                                                            .data
                                                                                            .vat,
                                                                                        expression:
                                                                                          "customer.data.vat"
                                                                                      }
                                                                                    ],
                                                                                    staticClass:
                                                                                      "uk-input",
                                                                                    attrs: {
                                                                                      type:
                                                                                        "text"
                                                                                    },
                                                                                    domProps: {
                                                                                      value:
                                                                                        _vm
                                                                                          .customer
                                                                                          .data
                                                                                          .vat
                                                                                    },
                                                                                    on: {
                                                                                      input: function(
                                                                                        $event
                                                                                      ) {
                                                                                        if (
                                                                                          $event
                                                                                            .target
                                                                                            .composing
                                                                                        ) {
                                                                                          return
                                                                                        }
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .customer
                                                                                            .data,
                                                                                          "vat",
                                                                                          $event
                                                                                            .target
                                                                                            .value
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("div", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "field-check uk-width-1-4@m"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-label uk-visible@m"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-danger"
                                                                      },
                                                                      [
                                                                        _vm.checkField !==
                                                                          "vat" &&
                                                                        ((errors.vat &&
                                                                          errors
                                                                            .vat
                                                                            .length >
                                                                            0) ||
                                                                          (errors.vatprefix &&
                                                                            errors
                                                                              .vatprefix
                                                                              .length >
                                                                              0) ||
                                                                          !_vm
                                                                            .customer
                                                                            .vatValid)
                                                                          ? [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step2-vaterror"
                                                                                    ]
                                                                                  ) +
                                                                                  "\n                              "
                                                                              )
                                                                            ]
                                                                          : _vm._e()
                                                                      ],
                                                                      2
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _vm.customer
                                                                      .vatValid &&
                                                                    _vm.customer
                                                                      .data.vat
                                                                      .length >
                                                                      0 &&
                                                                    _vm.checkField !==
                                                                      "vat"
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "uk-form-success uk-visible@m"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fas fa-check"
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "show",
                                                                            rawName:
                                                                              "v-show",
                                                                            value:
                                                                              _vm.checkField ===
                                                                              "vat",
                                                                            expression:
                                                                              "checkField === 'vat'"
                                                                          }
                                                                        ],
                                                                        staticClass:
                                                                          "uk-visible@m"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-circle-notch fa-spin"
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uk-flex uk-flex-between uk-margin-top"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "uk-button uk-button-secondary",
                                                        attrs: {
                                                          type: "button"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.previousStep
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-left"
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              ["i18n"][
                                                                "button-previous"
                                                              ]
                                                            )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "uk-button uk-button-primary",
                                                        attrs: {
                                                          type: "submit",
                                                          disabled:
                                                            invalid ||
                                                            _vm.checkField !==
                                                              "" ||
                                                            (_vm.vatRequired &&
                                                              (_vm.customer
                                                                .vatValid !==
                                                                true ||
                                                                _vm.customer
                                                                  .data.vat ===
                                                                  ""))
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.i18n[
                                                              "button-next"
                                                            ]
                                                          ) + " "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1555109785
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.step === 3
                          ? _c(
                              "li",
                              [
                                _c("h2", [
                                  _vm._v(
                                    "3. " + _vm._s(_vm.i18n["step3-headline"])
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.i18n["step3-text"])
                                  }
                                }),
                                _vm._v(" "),
                                _c("ValidationObserver", {
                                  ref: "step3",
                                  attrs: { tag: "div" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var invalid = ref.invalid
                                          var handleSubmit = ref.handleSubmit
                                          return [
                                            _c(
                                              "form",
                                              {
                                                staticClass: "uk-form-stacked",
                                                attrs: { novalidate: "" },
                                                on: {
                                                  submit: function($event) {
                                                    $event.preventDefault()
                                                    handleSubmit(_vm.toStep(4))
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uk-child-width-expand@s",
                                                    attrs: { "uk-grid": "" }
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "uk-form-label",
                                                          attrs: {
                                                            for: "email"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.i18n[
                                                                "step3-email"
                                                              ]
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "uk-form-controls uk-position-relative"
                                                        },
                                                        [
                                                          _vm.checkField === ""
                                                            ? [
                                                                _c("i", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        _vm.emailValid,
                                                                      expression:
                                                                        "emailValid"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                })
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c("i", {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm.checkField ===
                                                                  "email",
                                                                expression:
                                                                  "checkField === 'email'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "fas fa-circle-notch fa-spin uk-form-icon uk-form-icon-flip uk-hidden@m"
                                                          }),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.customer
                                                                    .data.email,
                                                                expression:
                                                                  "customer.data.email"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "uk-input",
                                                            class: {
                                                              "uk-form-success":
                                                                _vm.emailValid,
                                                              "uk-form-danger":
                                                                _vm.emailValid ==
                                                                false
                                                            },
                                                            attrs: {
                                                              type: "text"
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.customer
                                                                  .data.email
                                                            },
                                                            on: {
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  _vm.customer
                                                                    .data,
                                                                  "email",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              }
                                                            }
                                                          })
                                                        ],
                                                        2
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "field-check uk-width-1-4@m"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "uk-form-label uk-visible@m"
                                                          },
                                                          [_vm._v(" ")]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.emailValid === false
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "uk-form-danger"
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-times"
                                                                }),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.i18n[
                                                                        "step3-emailerror"
                                                                      ]
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm.emailValid &&
                                                                  _vm.checkField !==
                                                                    "email",
                                                                expression:
                                                                  "emailValid && checkField !== 'email'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "uk-form-success uk-visible@m"
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-check"
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("i", {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.checkField ===
                                                                "email",
                                                              expression:
                                                                "checkField === 'email'"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "fas fa-circle-notch fa-spin uk-visible@m"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("ValidationProvider", {
                                                  staticClass:
                                                    "uk-child-width-expand@s",
                                                  attrs: {
                                                    name: "phone",
                                                    rules: "",
                                                    tag: "div",
                                                    "uk-grid": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var dirty = ref.dirty
                                                          var passed =
                                                            ref.passed
                                                          var classes =
                                                            ref.classes
                                                          return [
                                                            _c("div", [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label",
                                                                  attrs: {
                                                                    for: "phone"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.i18n[
                                                                        "step3-phone"
                                                                      ]
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-controls uk-position-relative"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value:
                                                                          dirty &&
                                                                          passed,
                                                                        expression:
                                                                          "dirty && passed"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "model",
                                                                        rawName:
                                                                          "v-model",
                                                                        value:
                                                                          _vm
                                                                            .customer
                                                                            .data
                                                                            .phone,
                                                                        expression:
                                                                          "customer.data.phone"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-input",
                                                                    class: classes,
                                                                    attrs: {
                                                                      type:
                                                                        "text"
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm
                                                                          .customer
                                                                          .data
                                                                          .phone
                                                                    },
                                                                    on: {
                                                                      input: function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          _vm
                                                                            .customer
                                                                            .data,
                                                                          "phone",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "field-check uk-width-1-4@m"
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "uk-form-label uk-visible@m "
                                                                  },
                                                                  [_vm._v(" ")]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value:
                                                                          dirty &&
                                                                          passed &&
                                                                          _vm
                                                                            .customer
                                                                            .data
                                                                            .phone
                                                                            .length >
                                                                            0,
                                                                        expression:
                                                                          "dirty && passed && customer.data.phone .length > 0"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "uk-form-success uk-visible@m"
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "fas fa-check"
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uk-flex uk-flex-between uk-margin-top"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "uk-button uk-button-secondary",
                                                        attrs: {
                                                          type: "button"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.previousStep
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-left"
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              ["i18n"][
                                                                "button-previous"
                                                              ]
                                                            )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "uk-button uk-button-primary",
                                                        attrs: {
                                                          type: "submit",
                                                          disabled:
                                                            invalid ||
                                                            _vm.checkField !==
                                                              "" ||
                                                            !_vm.emailValid
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.i18n[
                                                              "button-next"
                                                            ]
                                                          ) + " "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2667969695
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.step === 4
                          ? _c("li", { staticClass: "cloudoffice" }, [
                              _c("div", {
                                staticClass: "uk-clearfix",
                                domProps: {
                                  innerHTML: _vm._s(_vm.i18n["step5-content"])
                                }
                              }),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _c(
                                "form",
                                {
                                  staticClass: "uk-clearfix uk-form-stacked",
                                  attrs: { novalidate: "" },
                                  on: {
                                    submit: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      _vm.billwerk.plans.cloudoffice.booked = true
                                      _vm.toStep(5)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "uk-child-width-expand@s",
                                      attrs: { "uk-grid": "" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "uk-flex uk-flex-column"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "uk-button uk-button-primary",
                                              attrs: { type: "submit" }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.i18n["step5-button-add"]
                                                ) + " "
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-arrow-right"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "uk-text-right uk-margin-top",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  _vm.billwerk.plans.cloudoffice.booked = false
                                                  _vm.toStep(5)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.i18n["step5-button-noadd"]
                                                ) + " "
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-arrow-right"
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "uk-flex-first@s" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "uk-button uk-button-secondary",
                                              attrs: { type: "button" },
                                              on: { click: _vm.previousStep }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-arrow-left"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.i18n["button-previous"]
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.step === 5
                          ? _c(
                              "li",
                              { staticClass: "payment" },
                              [
                                _c("h2", [
                                  _vm._v(
                                    _vm._s(_vm.i18n["step4-headline"]) + " "
                                  ),
                                  _c("i", { staticClass: "fas fa-lock fa-xs" })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "uk-margin" }, [
                                  _c(
                                    "div",
                                    { staticClass: "uk-form-controls" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "uk-margin-right uk-margin-bottom uk-display-block uk-display-inline@s"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.customer.payment.type,
                                                expression:
                                                  "customer.payment.type"
                                              }
                                            ],
                                            staticClass: "uk-radio",
                                            attrs: {
                                              value: "ccard",
                                              type: "radio",
                                              name: "paymentType"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.customer.payment.type,
                                                "ccard"
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.$set(
                                                  _vm.customer.payment,
                                                  "type",
                                                  "ccard"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass:
                                              "uk-margin-small-right ccardicon",
                                            attrs: {
                                              src:
                                                _vm.wpParams.template_path +
                                                "/assets/img/vue/cc-visa.png"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass:
                                              "uk-margin-small-right ccardicon",
                                            attrs: {
                                              src:
                                                _vm.wpParams.template_path +
                                                "/assets/img/vue/cc-mastercard.png"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass:
                                              "uk-margin-small-right ccardicon",
                                            attrs: {
                                              src:
                                                _vm.wpParams.template_path +
                                                "/assets/img/vue/cc-amex.png"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass:
                                              "uk-margin-small-right ccardicon",
                                            attrs: {
                                              src:
                                                _vm.wpParams.template_path +
                                                "/assets/img/vue/cc-discover.png"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass:
                                              "uk-margin-small-right ccardicon",
                                            attrs: {
                                              src:
                                                _vm.wpParams.template_path +
                                                "/assets/img/vue/cc-diners.png"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass:
                                              "uk-margin-small-right ccardicon",
                                            attrs: {
                                              src:
                                                _vm.wpParams.template_path +
                                                "/assets/img/vue/cc-jcb.png"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "uk-margin-right uk-display-block uk-display-inline@s"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.customer.payment.type,
                                                expression:
                                                  "customer.payment.type"
                                              }
                                            ],
                                            staticClass: "uk-radio",
                                            attrs: {
                                              value: "debit",
                                              type: "radio",
                                              name: "paymentType"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.customer.payment.type,
                                                "debit"
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.$set(
                                                  _vm.customer.payment,
                                                  "type",
                                                  "debit"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.i18n["step4-debit_sepa"]
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("ValidationObserver", {
                                  ref: "step5",
                                  attrs: { tag: "div" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var invalid = ref.invalid
                                          var errors = ref.errors
                                          var handleSubmit = ref.handleSubmit
                                          return [
                                            _c(
                                              "form",
                                              {
                                                staticClass: "uk-form-stacked",
                                                attrs: { novalidate: "" },
                                                on: {
                                                  submit: function($event) {
                                                    $event.preventDefault()
                                                    handleSubmit(_vm.toStep(6))
                                                  }
                                                }
                                              },
                                              [
                                                _vm.customer.payment.type ===
                                                "ccard"
                                                  ? [
                                                      _c("ValidationProvider", {
                                                        staticClass:
                                                          "uk-child-width-expand@s",
                                                        attrs: {
                                                          name: "ccholder",
                                                          rules: "required",
                                                          tag: "div",
                                                          "uk-grid": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var failed =
                                                                  ref.failed
                                                                var dirty =
                                                                  ref.dirty
                                                                var passed =
                                                                  ref.passed
                                                                var classes =
                                                                  ref.classes
                                                                return [
                                                                  _c("div", [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-label",
                                                                        attrs: {
                                                                          for:
                                                                            "email"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-ccholder"
                                                                            ]
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-position-relative"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  dirty &&
                                                                                  passed,
                                                                                expression:
                                                                                  "dirty && passed"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .ccard
                                                                                    .cardHolder,
                                                                                expression:
                                                                                  "customer.payment.ccard.cardHolder"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-input",
                                                                            class: classes,
                                                                            attrs: {
                                                                              type:
                                                                                "text"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm
                                                                                  .customer
                                                                                  .payment
                                                                                  .ccard
                                                                                  .cardHolder
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .ccard,
                                                                                  "cardHolder",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "field-check uk-width-1-4@m"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-label uk-visible@m "
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      dirty &&
                                                                      failed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "uk-form-danger"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step4-ccholdererror"
                                                                                    ]
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                dirty &&
                                                                                passed,
                                                                              expression:
                                                                                "dirty && passed"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "uk-form-success uk-visible@m"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-check"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _c("ValidationProvider", {
                                                        staticClass:
                                                          "uk-child-width-expand@s",
                                                        attrs: {
                                                          name: "ccnumber",
                                                          rules:
                                                            "required|credit_card",
                                                          tag: "div",
                                                          "uk-grid": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var failed =
                                                                  ref.failed
                                                                var dirty =
                                                                  ref.dirty
                                                                var passed =
                                                                  ref.passed
                                                                var classes =
                                                                  ref.classes
                                                                return [
                                                                  _c("div", [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-label",
                                                                        attrs: {
                                                                          for:
                                                                            "ccnumber"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-ccnumber"
                                                                            ]
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-position-relative"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  dirty &&
                                                                                  passed,
                                                                                expression:
                                                                                  "dirty && passed"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .ccard
                                                                                    .cardNumber,
                                                                                expression:
                                                                                  "customer.payment.ccard.cardNumber"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-input",
                                                                            class: classes,
                                                                            attrs: {
                                                                              id:
                                                                                "ccnumber",
                                                                              type:
                                                                                "text"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm
                                                                                  .customer
                                                                                  .payment
                                                                                  .ccard
                                                                                  .cardNumber
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .ccard,
                                                                                  "cardNumber",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        passed
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "uk-text-small"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .customer
                                                                                      .payment
                                                                                      .cardType
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "field-check uk-width-1-4@m"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-label uk-visible@m "
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      dirty &&
                                                                      failed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "uk-form-danger"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step4-ccnumbererror"
                                                                                    ]
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                dirty &&
                                                                                passed,
                                                                              expression:
                                                                                "dirty && passed"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "uk-form-success uk-visible@m"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-check"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _c("ValidationProvider", {
                                                        staticClass:
                                                          "uk-child-width-expand@s",
                                                        attrs: {
                                                          name: "cvc",
                                                          rules: "max:4|min:3",
                                                          tag: "div",
                                                          "uk-grid": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var failed =
                                                                  ref.failed
                                                                var dirty =
                                                                  ref.dirty
                                                                var passed =
                                                                  ref.passed
                                                                var classes =
                                                                  ref.classes
                                                                return [
                                                                  _c("div", [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-label",
                                                                        attrs: {
                                                                          for:
                                                                            "cvc"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-ccsecurity"
                                                                            ]
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-position-relative"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  dirty &&
                                                                                  passed,
                                                                                expression:
                                                                                  "dirty && passed"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .ccard
                                                                                    .cvc,
                                                                                expression:
                                                                                  "customer.payment.ccard.cvc"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-input",
                                                                            class: classes,
                                                                            attrs: {
                                                                              maxlength:
                                                                                "4",
                                                                              name:
                                                                                "cvc",
                                                                              type:
                                                                                "text"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm
                                                                                  .customer
                                                                                  .payment
                                                                                  .ccard
                                                                                  .cvc
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .ccard,
                                                                                  "cvc",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "field-check uk-width-1-4@m"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-label uk-visible@m "
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      dirty &&
                                                                      failed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "uk-form-danger"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step4-ccsecurityerror"
                                                                                    ]
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                dirty &&
                                                                                passed,
                                                                              expression:
                                                                                "dirty && passed"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "uk-form-success uk-visible@m"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-check"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "uk-child-width-expand@s uk-flex uk-grid-small",
                                                          attrs: {
                                                            "uk-grid": ""
                                                          }
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "uk-form-label",
                                                                attrs: {
                                                                  for:
                                                                    "ccExpiryMonth"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.i18n[
                                                                      "step4-ccexpires"
                                                                    ]
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                attrs: {
                                                                  "uk-grid": ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "ValidationProvider",
                                                                  {
                                                                    staticClass:
                                                                      "uk-form-controls uk-position-relative uk-width-1-2",
                                                                    attrs: {
                                                                      vid:
                                                                        "ccExpiryYear",
                                                                      name:
                                                                        "ccExpiryYear",
                                                                      rules:
                                                                        "required|required:@ccExpiryMonth|min_value:1",
                                                                      tag: "div"
                                                                    },
                                                                    scopedSlots: _vm._u(
                                                                      [
                                                                        {
                                                                          key:
                                                                            "default",
                                                                          fn: function(
                                                                            ref
                                                                          ) {
                                                                            var dirty =
                                                                              ref.dirty
                                                                            var passed =
                                                                              ref.passed
                                                                            var classes =
                                                                              ref.classes
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "uk-form-controls uk-position-relative"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "i",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "show",
                                                                                          rawName:
                                                                                            "v-show",
                                                                                          value:
                                                                                            dirty &&
                                                                                            passed,
                                                                                          expression:
                                                                                            "dirty && passed"
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "select",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "model",
                                                                                          rawName:
                                                                                            "v-model",
                                                                                          value:
                                                                                            _vm
                                                                                              .customer
                                                                                              .payment
                                                                                              .ccard
                                                                                              .expiryYear,
                                                                                          expression:
                                                                                            "customer.payment.ccard.expiryYear"
                                                                                        }
                                                                                      ],
                                                                                      key:
                                                                                        "expyear",
                                                                                      staticClass:
                                                                                        "uk-select",
                                                                                      class: classes,
                                                                                      attrs: {
                                                                                        id:
                                                                                          "ccexpiryYear",
                                                                                        name:
                                                                                          "ccexpiryYear"
                                                                                      },
                                                                                      on: {
                                                                                        change: function(
                                                                                          $event
                                                                                        ) {
                                                                                          var $$selectedVal = Array.prototype.filter
                                                                                            .call(
                                                                                              $event
                                                                                                .target
                                                                                                .options,
                                                                                              function(
                                                                                                o
                                                                                              ) {
                                                                                                return o.selected
                                                                                              }
                                                                                            )
                                                                                            .map(
                                                                                              function(
                                                                                                o
                                                                                              ) {
                                                                                                var val =
                                                                                                  "_value" in
                                                                                                  o
                                                                                                    ? o._value
                                                                                                    : o.value
                                                                                                return val
                                                                                              }
                                                                                            )
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .customer
                                                                                              .payment
                                                                                              .ccard,
                                                                                            "expiryYear",
                                                                                            $event
                                                                                              .target
                                                                                              .multiple
                                                                                              ? $$selectedVal
                                                                                              : $$selectedVal[0]
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "option",
                                                                                        {
                                                                                          key:
                                                                                            "0",
                                                                                          attrs: {
                                                                                            value:
                                                                                              "0",
                                                                                            selected:
                                                                                              "selected"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " "
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _vm._l(
                                                                                        _vm.ccyears,
                                                                                        function(
                                                                                          year
                                                                                        ) {
                                                                                          return _c(
                                                                                            "option",
                                                                                            {
                                                                                              key: year,
                                                                                              domProps: {
                                                                                                value: year
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  year
                                                                                                )
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        }
                                                                                      )
                                                                                    ],
                                                                                    2
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          }
                                                                        }
                                                                      ],
                                                                      null,
                                                                      true
                                                                    )
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "ValidationProvider",
                                                                  {
                                                                    staticClass:
                                                                      "uk-form-controls uk-width-1-2",
                                                                    attrs: {
                                                                      vid:
                                                                        "ccExpiryMonth",
                                                                      name:
                                                                        "ccExpiryMonth",
                                                                      rules:
                                                                        "required|required:@ccExpiryYear|min_value:1",
                                                                      tag: "div"
                                                                    },
                                                                    scopedSlots: _vm._u(
                                                                      [
                                                                        {
                                                                          key:
                                                                            "default",
                                                                          fn: function(
                                                                            ref
                                                                          ) {
                                                                            var dirty =
                                                                              ref.dirty
                                                                            var passed =
                                                                              ref.passed
                                                                            var classes =
                                                                              ref.classes
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "uk-form-controls uk-position-relative"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "i",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "show",
                                                                                          rawName:
                                                                                            "v-show",
                                                                                          value:
                                                                                            dirty &&
                                                                                            passed,
                                                                                          expression:
                                                                                            "dirty && passed"
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "select",
                                                                                    {
                                                                                      directives: [
                                                                                        {
                                                                                          name:
                                                                                            "model",
                                                                                          rawName:
                                                                                            "v-model",
                                                                                          value:
                                                                                            _vm
                                                                                              .customer
                                                                                              .payment
                                                                                              .ccard
                                                                                              .expiryMonth,
                                                                                          expression:
                                                                                            "customer.payment.ccard.expiryMonth"
                                                                                        }
                                                                                      ],
                                                                                      staticClass:
                                                                                        "uk-select",
                                                                                      class: classes,
                                                                                      attrs: {
                                                                                        name:
                                                                                          "ccexpiryMonth"
                                                                                      },
                                                                                      on: {
                                                                                        change: function(
                                                                                          $event
                                                                                        ) {
                                                                                          var $$selectedVal = Array.prototype.filter
                                                                                            .call(
                                                                                              $event
                                                                                                .target
                                                                                                .options,
                                                                                              function(
                                                                                                o
                                                                                              ) {
                                                                                                return o.selected
                                                                                              }
                                                                                            )
                                                                                            .map(
                                                                                              function(
                                                                                                o
                                                                                              ) {
                                                                                                var val =
                                                                                                  "_value" in
                                                                                                  o
                                                                                                    ? o._value
                                                                                                    : o.value
                                                                                                return val
                                                                                              }
                                                                                            )
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .customer
                                                                                              .payment
                                                                                              .ccard,
                                                                                            "expiryMonth",
                                                                                            $event
                                                                                              .target
                                                                                              .multiple
                                                                                              ? $$selectedVal
                                                                                              : $$selectedVal[0]
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "option",
                                                                                        {
                                                                                          key:
                                                                                            "0",
                                                                                          attrs: {
                                                                                            value:
                                                                                              "0",
                                                                                            selected:
                                                                                              "selected"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " "
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _vm._l(
                                                                                        _vm.ccmonths,
                                                                                        function(
                                                                                          month
                                                                                        ) {
                                                                                          return _c(
                                                                                            "option",
                                                                                            {
                                                                                              key: month,
                                                                                              domProps: {
                                                                                                value: month
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  month
                                                                                                )
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        }
                                                                                      )
                                                                                    ],
                                                                                    2
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          }
                                                                        }
                                                                      ],
                                                                      null,
                                                                      true
                                                                    )
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "field-check uk-width-1-4@m"
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "uk-form-label uk-visible@m"
                                                                },
                                                                [_vm._v(" ")]
                                                              ),
                                                              _vm._v(" "),
                                                              (errors.ccExpiryYear &&
                                                                errors
                                                                  .ccExpiryYear
                                                                  .length >
                                                                  0) ||
                                                              (errors.ccExpiryMonth &&
                                                                errors
                                                                  .ccExpiryMonth
                                                                  .length > 0)
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "uk-form-danger"
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fas fa-times"
                                                                      }),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-ccexpireserror"
                                                                            ]
                                                                          )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        errors.ccExpiryYear &&
                                                                        errors
                                                                          .ccExpiryYear
                                                                          .length ===
                                                                          0 &&
                                                                        _vm
                                                                          .customer
                                                                          .payment
                                                                          .ccard
                                                                          .expiryYear >
                                                                          0 &&
                                                                        errors.ccExpiryMonth &&
                                                                        errors
                                                                          .ccExpiryMonth
                                                                          .length ===
                                                                          0 &&
                                                                        _vm
                                                                          .customer
                                                                          .payment
                                                                          .ccard
                                                                          .expiryMonth >
                                                                          0,
                                                                      expression:
                                                                        "errors.ccExpiryYear && errors.ccExpiryYear.length === 0 && customer.payment.ccard.expiryYear > 0 && errors.ccExpiryMonth && errors.ccExpiryMonth.length === 0 && customer.payment.ccard.expiryMonth > 0"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "uk-form-success uk-visible@m"
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fas fa-check"
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("ValidationProvider", {
                                                        staticClass:
                                                          "uk-child-width-expand@s uk-flex uk-grid-small",
                                                        attrs: {
                                                          name: "cccountry",
                                                          rules: "required",
                                                          tag: "div",
                                                          "uk-grid": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var failed =
                                                                  ref.failed
                                                                var dirty =
                                                                  ref.dirty
                                                                var passed =
                                                                  ref.passed
                                                                var errors =
                                                                  ref.errors
                                                                var classes =
                                                                  ref.classes
                                                                return [
                                                                  _c("div", [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-label",
                                                                        attrs: {
                                                                          for:
                                                                            "cccountry"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-cccountry"
                                                                            ]
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-position-relative"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value: passed,
                                                                                expression:
                                                                                  "passed"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "select",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .ccard
                                                                                    .country,
                                                                                expression:
                                                                                  "customer.payment.ccard.country"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-select",
                                                                            class: classes,
                                                                            attrs: {
                                                                              id:
                                                                                "cccountry"
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                var $$selectedVal = Array.prototype.filter
                                                                                  .call(
                                                                                    $event
                                                                                      .target
                                                                                      .options,
                                                                                    function(
                                                                                      o
                                                                                    ) {
                                                                                      return o.selected
                                                                                    }
                                                                                  )
                                                                                  .map(
                                                                                    function(
                                                                                      o
                                                                                    ) {
                                                                                      var val =
                                                                                        "_value" in
                                                                                        o
                                                                                          ? o._value
                                                                                          : o.value
                                                                                      return val
                                                                                    }
                                                                                  )
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .ccard,
                                                                                  "country",
                                                                                  $event
                                                                                    .target
                                                                                    .multiple
                                                                                    ? $$selectedVal
                                                                                    : $$selectedVal[0]
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          _vm._l(
                                                                            _vm.countries.getNames(
                                                                              _vm
                                                                                .i18n
                                                                                .language
                                                                            ),
                                                                            function(
                                                                              country,
                                                                              index
                                                                            ) {
                                                                              return _c(
                                                                                "option",
                                                                                {
                                                                                  key: index,
                                                                                  domProps: {
                                                                                    value: index
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      country
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          0
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "field-check uk-width-1-4@m"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-label uk-visible@m"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      dirty &&
                                                                      failed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "uk-form-danger"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      errors[0]
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step4-cccountryerror"
                                                                                    ]
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value: passed,
                                                                              expression:
                                                                                "passed"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "uk-form-success uk-visible@m"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-check"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ]
                                                  : _vm.customer.payment
                                                      .type === "debit"
                                                  ? [
                                                      _c("ValidationProvider", {
                                                        staticClass:
                                                          "uk-child-width-expand@s",
                                                        attrs: {
                                                          name:
                                                            "debitAccountHolder",
                                                          rules: "required",
                                                          tag: "div",
                                                          "uk-grid": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var failed =
                                                                  ref.failed
                                                                var dirty =
                                                                  ref.dirty
                                                                var passed =
                                                                  ref.passed
                                                                var classes =
                                                                  ref.classes
                                                                return [
                                                                  _c("div", [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-label",
                                                                        attrs: {
                                                                          for:
                                                                            "debitAccountHolder"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm
                                                                              .i18n[
                                                                              "step4-debitaccountholder"
                                                                            ]
                                                                          )
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-position-relative"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  dirty &&
                                                                                  passed,
                                                                                expression:
                                                                                  "dirty && passed"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .debit
                                                                                    .accountHolder,
                                                                                expression:
                                                                                  "customer.payment.debit.accountHolder"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-input",
                                                                            class: classes,
                                                                            attrs: {
                                                                              name:
                                                                                "debitAccountHolder",
                                                                              type:
                                                                                "text"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm
                                                                                  .customer
                                                                                  .payment
                                                                                  .debit
                                                                                  .accountHolder
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .debit,
                                                                                  "accountHolder",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "field-check uk-width-1-4@m"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-label uk-visible@m"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      dirty &&
                                                                      failed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "uk-form-danger"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step4-debitaccountholdererror"
                                                                                    ]
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                dirty &&
                                                                                passed,
                                                                              expression:
                                                                                "dirty && passed"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "uk-form-success uk-visible@m"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-check"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _c("ValidationProvider", {
                                                        staticClass:
                                                          "uk-child-width-expand@s",
                                                        attrs: {
                                                          name: "debitIban",
                                                          rules:
                                                            "required|iban",
                                                          tag: "div",
                                                          "uk-grid": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var failed =
                                                                  ref.failed
                                                                var dirty =
                                                                  ref.dirty
                                                                var passed =
                                                                  ref.passed
                                                                var classes =
                                                                  ref.classes
                                                                return [
                                                                  _c("div", [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-label",
                                                                        attrs: {
                                                                          for:
                                                                            "debitIban"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "IBAN"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-position-relative"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  dirty &&
                                                                                  passed,
                                                                                expression:
                                                                                  "dirty && passed"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .debit
                                                                                    .iban,
                                                                                expression:
                                                                                  "customer.payment.debit.iban"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-input",
                                                                            class: classes,
                                                                            attrs: {
                                                                              name:
                                                                                "debitIban",
                                                                              type:
                                                                                "text"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm
                                                                                  .customer
                                                                                  .payment
                                                                                  .debit
                                                                                  .iban
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .debit,
                                                                                  "iban",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "field-check uk-width-1-4@m"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-label uk-visible@m"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      dirty &&
                                                                      failed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "uk-form-danger"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step4-debitibanerror"
                                                                                    ]
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                dirty &&
                                                                                passed,
                                                                              expression:
                                                                                "dirty && passed"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "uk-form-success uk-visible@m"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-check"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _c("ValidationProvider", {
                                                        staticClass:
                                                          "uk-child-width-expand@s",
                                                        attrs: {
                                                          name: "debitBic",
                                                          rules: "",
                                                          tag: "div",
                                                          "uk-grid": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var failed =
                                                                  ref.failed
                                                                var dirty =
                                                                  ref.dirty
                                                                var passed =
                                                                  ref.passed
                                                                var classes =
                                                                  ref.classes
                                                                return [
                                                                  _c("div", [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-label",
                                                                        attrs: {
                                                                          for:
                                                                            "debitBic"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "BIC"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "uk-form-controls uk-position-relative"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "show",
                                                                                rawName:
                                                                                  "v-show",
                                                                                value:
                                                                                  dirty &&
                                                                                  passed &&
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .debit
                                                                                    .bic
                                                                                    .length >
                                                                                    0,
                                                                                expression:
                                                                                  "dirty && passed && customer.payment.debit.bic.length > 0"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "fas fa-check uk-form-icon uk-form-icon-flip uk-hidden@m uk-text-success"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .debit
                                                                                    .bic,
                                                                                expression:
                                                                                  "customer.payment.debit.bic"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-input",
                                                                            class: classes,
                                                                            attrs: {
                                                                              name:
                                                                                "debitBic",
                                                                              type:
                                                                                "text"
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm
                                                                                  .customer
                                                                                  .payment
                                                                                  .debit
                                                                                  .bic
                                                                            },
                                                                            on: {
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .customer
                                                                                    .payment
                                                                                    .debit,
                                                                                  "bic",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "field-check uk-width-1-4@m"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-label uk-visible@m"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      dirty &&
                                                                      failed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "uk-form-danger"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step4-debitbicerror"
                                                                                    ]
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                dirty &&
                                                                                passed &&
                                                                                _vm
                                                                                  .customer
                                                                                  .payment
                                                                                  .debit
                                                                                  .bic
                                                                                  .length >
                                                                                  0,
                                                                              expression:
                                                                                "dirty && passed && customer.payment.debit.bic.length > 0"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "uk-form-success uk-visible@m"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-check"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _c("ValidationProvider", {
                                                        staticClass:
                                                          "uk-child-width-expand@s",
                                                        attrs: {
                                                          name: "debitMandate",
                                                          rules: {
                                                            required: {
                                                              allowFalse: false
                                                            }
                                                          },
                                                          tag: "div",
                                                          "uk-grid": ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var failed =
                                                                  ref.failed
                                                                var dirty =
                                                                  ref.dirty
                                                                var passed =
                                                                  ref.passed
                                                                var classes =
                                                                  ref.classes
                                                                return [
                                                                  _c("div", [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-checkbox-label"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .mandateAccepted,
                                                                                expression:
                                                                                  "customer.mandateAccepted"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-checkbox",
                                                                            class: classes,
                                                                            attrs: {
                                                                              name:
                                                                                "mandateAccepted",
                                                                              type:
                                                                                "checkbox"
                                                                            },
                                                                            domProps: {
                                                                              value: true,
                                                                              checked: Array.isArray(
                                                                                _vm
                                                                                  .customer
                                                                                  .mandateAccepted
                                                                              )
                                                                                ? _vm._i(
                                                                                    _vm
                                                                                      .customer
                                                                                      .mandateAccepted,
                                                                                    true
                                                                                  ) >
                                                                                  -1
                                                                                : _vm
                                                                                    .customer
                                                                                    .mandateAccepted
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                var $$a =
                                                                                    _vm
                                                                                      .customer
                                                                                      .mandateAccepted,
                                                                                  $$el =
                                                                                    $event.target,
                                                                                  $$c = $$el.checked
                                                                                    ? true
                                                                                    : false
                                                                                if (
                                                                                  Array.isArray(
                                                                                    $$a
                                                                                  )
                                                                                ) {
                                                                                  var $$v = true,
                                                                                    $$i = _vm._i(
                                                                                      $$a,
                                                                                      $$v
                                                                                    )
                                                                                  if (
                                                                                    $$el.checked
                                                                                  ) {
                                                                                    $$i <
                                                                                      0 &&
                                                                                      _vm.$set(
                                                                                        _vm.customer,
                                                                                        "mandateAccepted",
                                                                                        $$a.concat(
                                                                                          [
                                                                                            $$v
                                                                                          ]
                                                                                        )
                                                                                      )
                                                                                  } else {
                                                                                    $$i >
                                                                                      -1 &&
                                                                                      _vm.$set(
                                                                                        _vm.customer,
                                                                                        "mandateAccepted",
                                                                                        $$a
                                                                                          .slice(
                                                                                            0,
                                                                                            $$i
                                                                                          )
                                                                                          .concat(
                                                                                            $$a.slice(
                                                                                              $$i +
                                                                                                1
                                                                                            )
                                                                                          )
                                                                                      )
                                                                                  }
                                                                                } else {
                                                                                  _vm.$set(
                                                                                    _vm.customer,
                                                                                    "mandateAccepted",
                                                                                    $$c
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .i18n[
                                                                                "step4-debitsepamandate"
                                                                              ]
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "field-check uk-width-1-4@m"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "uk-form-label uk-visible@m"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      dirty &&
                                                                      failed
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "uk-form-danger"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "fas fa-times"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .i18n[
                                                                                      "step4-debitsepamandateerror"
                                                                                    ]
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "show",
                                                                              rawName:
                                                                                "v-show",
                                                                              value:
                                                                                dirty &&
                                                                                passed,
                                                                              expression:
                                                                                "dirty && passed"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "uk-form-success uk-visible@m"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-check"
                                                                            }
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uk-flex uk-flex-between uk-margin-top"
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "uk-button uk-button-secondary",
                                                        attrs: {
                                                          type: "button"
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.previousStep
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-left"
                                                        }),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              ["i18n"][
                                                                "button-previous"
                                                              ]
                                                            )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "uk-button uk-button-primary",
                                                        attrs: {
                                                          type: "submit",
                                                          disabled:
                                                            invalid ||
                                                            _vm.checkField !==
                                                              ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.i18n[
                                                              "button-next"
                                                            ]
                                                          ) + " "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    217068198
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.step === 6
                          ? _c(
                              "li",
                              [
                                _c("ValidationObserver", {
                                  ref: "step5",
                                  attrs: { tag: "div" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var invalid = ref.invalid
                                          var handleSubmit = ref.handleSubmit
                                          return [
                                            _c(
                                              "form",
                                              {
                                                staticClass: "uk-form-stacked",
                                                attrs: { novalidate: "" },
                                                on: {
                                                  submit: function($event) {
                                                    $event.preventDefault()
                                                    return handleSubmit(
                                                      _vm.signup
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "uk-width-1-2@m uk-text-center uk-margin-auto uk-margin"
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "uk-clearfix",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.i18n[
                                                            "finish-content"
                                                          ]
                                                        )
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("hr"),
                                                    _vm._v(" "),
                                                    _c("ValidationProvider", {
                                                      attrs: {
                                                        name: "termsAccepted",
                                                        rules: {
                                                          required: {
                                                            allowFalse: false
                                                          }
                                                        },
                                                        tag: "div"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var failed =
                                                                ref.failed
                                                              var dirty =
                                                                ref.dirty
                                                              var classes =
                                                                ref.classes
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "uk-margin"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        staticClass:
                                                                          "uk-checkbox-label"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .customer
                                                                                    .termsAccepted,
                                                                                expression:
                                                                                  "customer.termsAccepted"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "uk-checkbox",
                                                                            class: classes,
                                                                            attrs: {
                                                                              name:
                                                                                "termsAccepted",
                                                                              type:
                                                                                "checkbox"
                                                                            },
                                                                            domProps: {
                                                                              value: true,
                                                                              checked: Array.isArray(
                                                                                _vm
                                                                                  .customer
                                                                                  .termsAccepted
                                                                              )
                                                                                ? _vm._i(
                                                                                    _vm
                                                                                      .customer
                                                                                      .termsAccepted,
                                                                                    true
                                                                                  ) >
                                                                                  -1
                                                                                : _vm
                                                                                    .customer
                                                                                    .termsAccepted
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                var $$a =
                                                                                    _vm
                                                                                      .customer
                                                                                      .termsAccepted,
                                                                                  $$el =
                                                                                    $event.target,
                                                                                  $$c = $$el.checked
                                                                                    ? true
                                                                                    : false
                                                                                if (
                                                                                  Array.isArray(
                                                                                    $$a
                                                                                  )
                                                                                ) {
                                                                                  var $$v = true,
                                                                                    $$i = _vm._i(
                                                                                      $$a,
                                                                                      $$v
                                                                                    )
                                                                                  if (
                                                                                    $$el.checked
                                                                                  ) {
                                                                                    $$i <
                                                                                      0 &&
                                                                                      _vm.$set(
                                                                                        _vm.customer,
                                                                                        "termsAccepted",
                                                                                        $$a.concat(
                                                                                          [
                                                                                            $$v
                                                                                          ]
                                                                                        )
                                                                                      )
                                                                                  } else {
                                                                                    $$i >
                                                                                      -1 &&
                                                                                      _vm.$set(
                                                                                        _vm.customer,
                                                                                        "termsAccepted",
                                                                                        $$a
                                                                                          .slice(
                                                                                            0,
                                                                                            $$i
                                                                                          )
                                                                                          .concat(
                                                                                            $$a.slice(
                                                                                              $$i +
                                                                                                1
                                                                                            )
                                                                                          )
                                                                                      )
                                                                                  }
                                                                                } else {
                                                                                  _vm.$set(
                                                                                    _vm.customer,
                                                                                    "termsAccepted",
                                                                                    $$c
                                                                                  )
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            domProps: {
                                                                              innerHTML: _vm._s(
                                                                                _vm
                                                                                  .i18n
                                                                                  .terms
                                                                              )
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("div", [
                                                                  dirty &&
                                                                  failed
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "uk-margin uk-form-danger"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-times"
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .i18n[
                                                                                  "termserror"
                                                                                ]
                                                                              )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "errorDisplay"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.orderSucceeded ===
                                                              false,
                                                            expression:
                                                              "orderSucceeded === false"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "uk-alert uk-alert-danger uk-margin uk-width-1-1"
                                                      },
                                                      [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.i18n[
                                                                "step4-generalerror"
                                                              ]
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.orderError
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.paymentVerified ===
                                                                false &&
                                                              _vm.customer
                                                                .payment
                                                                .type ===
                                                                "ccard",
                                                            expression:
                                                              "paymentVerified === false && customer.payment.type === 'ccard'"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "uk-alert uk-alert-danger uk-margin uk-width-1-1"
                                                      },
                                                      [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.i18n[
                                                                "step4-ccvalidationerror"
                                                              ]
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.paymentVerified ===
                                                                false &&
                                                              _vm.customer
                                                                .payment
                                                                .type ===
                                                                "debit",
                                                            expression:
                                                              "paymentVerified === false && customer.payment.type === 'debit'"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "uk-alert uk-alert-danger uk-margin uk-width-1-1"
                                                      },
                                                      [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.i18n[
                                                                "step4-debiterrortext"
                                                              ]
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "uk-width-1-2@m uk-text-center uk-margin-auto"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "uk-button uk-button-primary uk-display-block uk-margin-auto uk-button-large",
                                                            attrs: {
                                                              type: "submit",
                                                              disabled:
                                                                invalid ||
                                                                _vm.status ===
                                                                  "saving"
                                                            }
                                                          },
                                                          [
                                                            _vm.status ===
                                                            "saving"
                                                              ? [_vm._v(" ...")]
                                                              : [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.i18n[
                                                                        "finish-button-complete2"
                                                                      ]
                                                                    )
                                                                  )
                                                                ]
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "uk-button uk-button-secondary uk-display-block uk-margin-auto uk-margin-top",
                                                            attrs: {
                                                              type: "button"
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.previousStep
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-arrow-left"
                                                            }),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.i18n[
                                                                    "button-previous"
                                                                  ]
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3143421334
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sidebar uk-width-1-3@m" }, [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "summary uk-position-relative",
                class: {
                  working:
                    _vm.status === "updateing_summary" ||
                    _vm.status === "saving",
                  "uk-hidden": _vm.status === "done"
                },
                staticStyle: { "z-index": "980" }
              },
              [
                _c(
                  "div",
                  { staticClass: "logo_wrap uk-text-center" },
                  [
                    _c("oc-logo", {
                      staticClass: "uk-margin-bottom",
                      attrs: { animated: "animated" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "summary_content uk-text-small" }, [
                  _c("div", [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.i18n.plans[this.customer.plan.variant].name)
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.i18n.plans[this.customer.plan.variant].intro
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.billwerk.plans.cloudoffice.booked,
                          expression: "billwerk.plans.cloudoffice.booked"
                        }
                      ]
                    },
                    [
                      _c("h3", [_vm._v("+ Cloud Office")]),
                      _vm._v(" "),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.i18n.plans.cloudoffice.intro)
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "table",
                    { staticClass: "uk-table uk-table-small uk-table-divider" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.i18n["order_summary"]["buy-summary-item"]
                                ) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.i18n["order_summary"]["buy-summary-price"]
                                ) +
                                "\n                  "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.customer.plan.users) +
                              " " +
                              _vm._s(
                                _vm.i18n["order_summary"]["buy-summary-users"]
                              ) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.totalStorageComp) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.preview.Total,
                                    _vm.currencies[_vm.activeCurrency]
                                  )
                                ) +
                                " "
                            ),
                            _vm.customer.plan.interval === "yearly"
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.i18n["buy-summary-peryear"])
                                  )
                                ]
                              : [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.i18n["buy-summary-permonth"])
                                  )
                                ]
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.customer.plan.interval === "yearly" &&
                                typeof this.customer.plan.variant.monthly !==
                                  "undefined",
                              expression:
                                "customer.plan.interval === 'yearly' && typeof this.customer.plan.variant.monthly !== 'undefined'"
                            }
                          ],
                          staticClass: "highlight"
                        },
                        [
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.i18n["order_summary"][
                                    "buy-summary-savings"
                                  ]
                                ) +
                                " (" +
                                _vm._s(_vm.yearlySavingsProcComp) +
                                "%)\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                  - " +
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.yearlySavingsComp,
                                    _vm.currencies[_vm.activeCurrency]
                                  )
                                ) +
                                "\n                "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.coupon.status,
                              expression: "coupon.status"
                            }
                          ]
                        },
                        [
                          _c("td", [
                            _vm._v(
                              "\n                  Coupon-Code\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.customer.data.coupon) +
                                "\n                "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.billwerk.plans.cloudoffice.booked,
                              expression: "billwerk.plans.cloudoffice.booked"
                            }
                          ]
                        },
                        [
                          _c("td", [
                            _vm._v(
                              "\n                  Cloud-Office\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.cloudOfficePriceComp,
                                    _vm.currencies[_vm.activeCurrency]
                                  )
                                ) +
                                "\n                "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.vat > 0,
                              expression: "vat > 0"
                            }
                          ]
                        },
                        [
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.i18n["order_summary"]["buy-summary-vat"]
                                ) +
                                " (" +
                                _vm._s(_vm.vat) +
                                " %)\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.preview.TotalVat,
                                    _vm.currencies[_vm.activeCurrency]
                                  )
                                ) +
                                "\n                "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("tr", { staticClass: "total" }, [
                        _c("td", { staticClass: "uk-text-bold" }, [
                          _vm._v("\n                  Total:\n                ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "uk-text-bold" },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.preview.TotalGross,
                                    _vm.currencies[_vm.activeCurrency]
                                  )
                                ) +
                                " "
                            ),
                            _vm.customer.plan.interval === "yearly"
                              ? [_vm._v("per year")]
                              : [_vm._v("per month")]
                          ],
                          2
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "currency-chooser uk-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "uk-width-1-4 uk-text-center",
                        class: { active: _vm.activeCurrency === "euro" },
                        on: {
                          click: function($event) {
                            _vm.activeCurrency = "euro"
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "euro-sign"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "uk-width-1-4 uk-text-center",
                        class: { active: _vm.activeCurrency === "dollar" },
                        on: {
                          click: function($event) {
                            _vm.activeCurrency = "dollar"
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "dollar-sign"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "uk-width-1-4 uk-text-center",
                        class: { active: _vm.activeCurrency === "pound" },
                        on: {
                          click: function($event) {
                            _vm.activeCurrency = "pound"
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "pound-sign"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "uk-width-1-4 uk-text-center",
                        class: { active: _vm.activeCurrency === "yen" },
                        on: {
                          click: function($event) {
                            _vm.activeCurrency = "yen"
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "yen-sign"] }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "uk-width-1-4 uk-text-center",
                        class: { active: _vm.activeCurrency === "bitcoin" },
                        on: {
                          click: function($event) {
                            _vm.activeCurrency = "bitcoin"
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fab", "bitcoin"] }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "note" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm._f("replace")(
                      _vm.i18n["order_summary"]["buy-summary-rates-text"],
                      "date",
                      _vm.rates.date
                    )
                  ) +
                  "\n          Exchange rates are dated " +
                  _vm._s(this.rates.date) +
                  " and are meant as guidance. Exact price will be calculated on checkout.\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "uk-margin-top",
              domProps: { innerHTML: _vm._s(this["i18n"]["buy-left_sidebar"]) }
            })
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "loading-overlay",
        class: { visible: _vm.status === "saving" }
      },
      [_c("ocLogo", { attrs: { animated: true } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }